































import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import * as prescriptionStatus from '@/settings/consts/prescription-status';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import IPrescription from '@/interfaces/prescription';
import { ITranscription } from '@/interfaces/transcription';
import { getLocalUser } from '@/services/session-data';

@Component({
  components: { PermissionAuth },
})
export default class PrescriptionListTranscriptionSubTable extends BaseComponent {
  @Prop()
  public transcription!: ITranscription;
  public headers: any[] = [
    { text: 'ID', value: 'idPrescricao', sortable: false },
    { text: 'Responsável', value: 'responsavel.nome', sortable: false },
    {
      text: 'Data do agendamento',
      value: 'dataPrescricaoTime',
      sortable: false,
    },
    { text: 'Unidade', value: 'unidade.nome', sortable: false },
    { text: 'Médico', value: 'medico.nome', sortable: false },
    { text: 'Paciente', value: 'paciente.nome', sortable: false },
    {
      text: 'Status',
      value: 'statusPrescricao',
      align: 'center',
      sortable: false,
    },
    {
      text: 'Ações',
      value: 'actions',
      align: 'center',
      sortable: false,
    },
  ];
  public currentUserId: string = null;

  public beforeMount(): void {
    getLocalUser().subscribe((currentUser) => {
      this.currentUserId = currentUser.idLogin;
    });
  }

  public getStatus(item: IPrescription): any {
    let statusObject;

    switch (item.statusPrescricao) {
      case prescriptionStatus.WAITING_CLIENT.key:
        statusObject = prescriptionStatus.WAITING_CLIENT;
        break;
      case prescriptionStatus.WAITING_EMEDE.key:
        statusObject = prescriptionStatus.WAITING_EMEDE;
        break;
      case prescriptionStatus.SCHEDULED_PRODUCTION.key:
        statusObject = prescriptionStatus.SCHEDULED_PRODUCTION;
        break;
      case prescriptionStatus.SENT_TO_PRODUCTION.key:
        statusObject = prescriptionStatus.SENT_TO_PRODUCTION;
        break;
      case prescriptionStatus.WAITING_PHARMACEUTICAL_APPROVE.key:
        statusObject = prescriptionStatus.WAITING_PHARMACEUTICAL_APPROVE;
        break;
      case prescriptionStatus.WAITING_TRANSCRIPTION.key:
        statusObject = prescriptionStatus.WAITING_TRANSCRIPTION;
        break;
      case prescriptionStatus.CHECKED_TRANSCRIPTION.key:
        statusObject = prescriptionStatus.CHECKED_TRANSCRIPTION;
        break;
      case prescriptionStatus.DENIED.key:
        statusObject = prescriptionStatus.DENIED;
        break;
      case prescriptionStatus.ERROR_ON_SEND_TO_PRODUCTION.key:
        statusObject = prescriptionStatus.ERROR_ON_SEND_TO_PRODUCTION;
        break;
      case prescriptionStatus.CANCELED_IN_PRODUCTION.key:
        statusObject = prescriptionStatus.CANCELED_IN_PRODUCTION;
        break;
      default:
        statusObject = {};
    }

    return statusObject;
  }

  public onViewItem(item: any): void {
    this.$emit('view', item, this.transcription.id);
  }
}
